import { Outlet, Link, useLocation, useNavigate } from 'react-router-dom'
import { useEffect, useState } from 'react'
import apiClient from '../api/client'
import './Layout.css'

function Layout(): JSX.Element {
  const location = useLocation()
  const navigate = useNavigate()
  const [isAdmin, setIsAdmin] = useState(false)

  useEffect(() => {
    apiClient
      .get<{ role: string }>('/auth/me')
      .then((res) => {
        const data = res.data as { role: string }
        setIsAdmin(data.role === 'admin')
      })
      .catch(() => {})
  }, [])

  const navItems = [
    { to: '/dashboard', label: 'Dashboard' },
    { to: '/research/new', label: 'New Research' },
    { to: '/search', label: 'Search' },
    ...(isAdmin ? [{ to: '/admin/users', label: 'Users' }] : []),
  ]

  const handleLogout = async () => {
    try {
      await apiClient.post('/auth/logout')
    } catch {}
    navigate('/login')
  }

  return (
    <div className="layout">
      <header className="layout-header">
        <div className="layout-brand">
          <Link to="/dashboard" className="layout-logo">
            BibPipeline
          </Link>
        </div>
        <nav className="layout-nav">
          {navItems.map((item) => (
            <Link
              key={item.to}
              to={item.to}
              className={`layout-nav-link ${location.pathname === item.to ? 'active' : ''}`}
            >
              {item.label}
            </Link>
          ))}
        </nav>
        <div className="layout-actions">
          <button className="layout-logout" onClick={handleLogout}>
            Log out
          </button>
        </div>
      </header>
      <main className="layout-main">
        <Outlet />
      </main>
    </div>
  )
}

export default Layout
